import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMail = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1.125em",
	height: "1.125em",
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M20 8.86816L12.5547 13.832C12.2188 14.056 11.7812 14.056 11.4453 13.832L4 8.86816V17C4 17.2652 4.10543 17.5195 4.29297 17.707C4.48051 17.8946 4.73478 18 5 18H19C19.2652 18 19.5195 17.8946 19.707 17.707C19.8946 17.5195 20 17.2652 20 17V8.86816ZM5 6C4.73478 6 4.4805 6.10543 4.29297 6.29297C4.21971 6.36623 4.1591 6.44972 4.1123 6.54004L12 11.7979L19.8867 6.54004C19.8399 6.44987 19.7802 6.36612 19.707 6.29297C19.5195 6.10543 19.2652 6 19 6H5ZM22 17C22 17.7957 21.6837 18.5585 21.1211 19.1211C20.5585 19.6837 19.7957 20 19 20H5C4.20435 20 3.44151 19.6837 2.87891 19.1211C2.3163 18.5585 2 17.7956 2 17V7C2 6.20435 2.3163 5.44152 2.87891 4.87891C3.44152 4.3163 4.20435 4 5 4H19C19.7957 4 20.5585 4.3163 21.1211 4.87891C21.6837 5.44152 22 6.20435 22 7V17Z",
		fill: "#52525B"
	})
});
export default SvgMail;
